import Model, { attr, belongsTo } from '@ember-data/model';
import type GroupInvite from 'garaje/models/group-invite';

export default class GroupInviteInstanceTemplate extends Model {
  @attr('string') declare fullName: string;
  @attr('string') declare email: string;
  @attr('number') declare additionalGuests: number;
  @attr('string') declare privateNotes: string;
  @attr('string') declare propertyNotes: string;
  @attr('immutable') declare userData: Readonly<Record<string, string>>;

  @belongsTo('group-invite', { async: false, inverse: 'inviteTemplates' }) declare groupInvite: GroupInvite;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'group-invite-instance-template': GroupInviteInstanceTemplate;
  }
}
